import React from "react"
import { Router, Route, Switch, Redirect } from "react-router-dom"
import Header from "organisms/Header"
import Footer from "organisms/Footer"
import history from "utils/history"
import ServiceAgreement from "pages/ServiceAgreement"
import SorryPage from "pages/SorryPage"

const SampleRouter = () => (
  <Router history={history}>
    <Header />
    <Switch>
      <Route path="/SorryPage">
        <SorryPage />
      </Route>
      <Route path="/:id">
        <ServiceAgreement />
      </Route>
      <Route path="/">
        <Redirect to="/SorryPage" />
      </Route>
    </Switch>
    <Footer />
  </Router>
)

export default SampleRouter
